import React from 'react';
import { Award, Users, Heart } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export const AboutSection = () => {
  return (
    <section id="about" className="section" data-testid="about-section">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold mb-6" style={{ color: 'var(--sage-dark)' }}>
            Welcome to Tri-City Internists
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            We are a dedicated internal medicine practice providing comprehensive adult healthcare
            with a focus on prevention, chronic disease management, and overall wellness. Our
            team-based approach ensures you receive attentive, personalized treatment for all
            your healthcare needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {[
            { icon: Award, title: 'Board-Certified Excellence', text: 'Our physicians are board-certified in internal medicine, ensuring the highest standards of medical care.' },
            { icon: Users, title: 'Team-Based Care', text: 'Collaborative approach with experienced physicians and certified nurse practitioners for comprehensive care.' },
            { icon: Heart, title: 'Patient-Centered Focus', text: 'Long-term relationships built on trust, compassion, and commitment to your quality of life.' }
          ].map(({ icon: Icon, title, text }) => (
            <Card key={title} className="text-center border-t-4 hover:shadow-lg transition-shadow" style={{ borderTopColor: 'var(--earth-accent)' }}>
              <CardContent className="pt-8 pb-6">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'rgba(139, 111, 71, 0.1)' }}>
                  <Icon className="w-8 h-8" style={{ color: 'var(--earth-accent)' }} />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--sage-dark)' }}>{title}</h3>
                <p className="text-gray-600">{text}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
